import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
// import { Keyboard } from "@ionic-native/keyboard/ngx";
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'custom-okr-dropdown',
  templateUrl: './custom-okr-dropdown.component.html',
  styleUrls: ['./custom-okr-dropdown.component.scss']
})
export class CustomOkrDropdownComponent implements OnInit {
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  @ViewChild('dropdown') dropdown: BsDropdownDirective;
  @Output() getResponse = new EventEmitter();
  @Output() onScrollToEnd = new EventEmitter<any>();

  searchText: string;
  searchTextChanged: Subject<string> = new Subject<string>();
  @Input() data: any[] = [];
  @Input() isManagerOkr: boolean = false;
  allDataList: any[] = [];
  allFilteredDataList: any[] = [];
  @Input() disabled = false;
  @Input() selectionMultiple: boolean = false;
  @Input() label: string;
  @Input() isRequired: boolean = false;
  @Input() searchManually: boolean = false;
  @Input() language;

  throttle = 50;
  scrollDistance = 2;
  scrollUpDistance = 2;
  pageStart = 1;
  pageSize = 200;
  currentList = [];
  isMobile: boolean;
  showMandatory = false;
  searchable = false;
  isOpened = false;
  subsc: Subscription;
  userInfo: any;

  constructor(
    private _renderer: Renderer2,
    public coreService: CoreService,
    private ref: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
    // private keyboard: Keyboard,
  ) {
    this.searchTextChanged
      .pipe(
        debounceTime(1000), // wait 500ms after the last event before emitting last event
        distinctUntilChanged()
      ) // only emit if value is different from previous value
      .subscribe((model) => {
        this.searchText = model;
        this.filter();
      });
  }

  ngOnInit() {
    this.userInfo = this.coreService.getUserInfo();
    this.data.forEach((x) => {
      if (x.Employee.Id === this.userInfo.linkedEmployeeId) {
        x.Employee.Picture = this.userInfo.imageUrl;
      }
    });
    this.initDataList();
    this.subsc = this.coreService.getEmpClearFilter().subscribe((emps) => {
      if (emps) {
        this.clearSelectionById(emps);
      }
    });
    // console.log("dddd",this.data);
  }

  ngOnDestroy(): void {
    this.subsc.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.setReadOnly();
  }

  setReadOnly() {
    if (this.searchManually && !this.searchable) {
      this._renderer.setAttribute(
        this.searchInput.nativeElement,
        'readonly',
        'true'
      );
    }
  }

  initDataList() {
    if (!this.data?.length) {
      return;
    }
    const selectedEmployees = this.data.filter((x) => x.IsLinked);
    this.setSelected(selectedEmployees);
    this.allDataList = JSON.parse(JSON.stringify(this.data));
    this.allDataList.sort((a, b) => {
      const nameA = a.ObjectiveName?.trim().toLowerCase() || '';
      const nameB = b.ObjectiveName?.trim().toLowerCase() || '';
      if (!nameA && nameB) return -1;
      if (nameA && !nameB) return 1;
      return nameA.localeCompare(nameB);
    });
    // console.log(this.allDataList);
    this.allFilteredDataList = JSON.parse(JSON.stringify(this.data));
    this.allFilteredDataList.sort((a, b) => {
      const nameA = a.ObjectiveName?.trim().toLowerCase() || '';
      const nameB = b.ObjectiveName?.trim().toLowerCase() || '';
      if (!nameA && nameB) return -1;
      if (nameA && !nameB) return 1;
      return nameA.localeCompare(nameB);
    });

    this.getEmployees();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;
      this.initDataList();
    }
  }

  ngAfterViewChecked() {
    this.isMobile = this.deviceService.isMobile();
  }

  onScrollDown() {
    const scrollingElement = document.getElementById('scrolling');
    if (scrollingElement) {
      this.onScrollToEnd.emit({
        endIndex: this.data.length - 1
      });
    }
  }

  async searchChanged(text: string) {
    if (!this.searchManually) {
      const textted = await JSON.parse(JSON.stringify(text));
      this.searchTextChanged.next(textted);
    } else {
      const textted = await JSON.parse(JSON.stringify(text));
      this.searchTextChanged.next(textted);
    }
  }

  getEmployees(isSearched = false) {
    let start = (this.pageStart - 1) * this.pageSize;
    let end = this.pageStart * this.pageSize;
    let pagedData = this.allFilteredDataList.slice(start, end);

    if (this.pageStart == 1) {
      this.currentList = pagedData;
      this.currentList.sort((a, b) => {
        const nameA = a.ObjectiveName?.trim().toLowerCase() || '';
        const nameB = b.ObjectiveName?.trim().toLowerCase() || '';
        if (!nameA && nameB) return -1;
        if (nameA && !nameB) return 1;
        return nameA.localeCompare(nameB);
      });
    } else {
      this.currentList = this.currentList.concat(pagedData);
      this.currentList.sort((a, b) => {
        const nameA = a.ObjectiveName?.trim().toLowerCase() || '';
        const nameB = b.ObjectiveName?.trim().toLowerCase() || '';
        if (!nameA && nameB) return -1;
        if (nameA && !nameB) return 1;
        return nameA.localeCompare(nameB);
      });
    }
    if (this.currentList.length > 0 && this.selectionMultiple) {
      this.currentList.sort((a, b) => {
        const nameA = a.ObjectiveName?.trim().toLowerCase() || '';
        const nameB = b.ObjectiveName?.trim().toLowerCase() || '';
        if (!nameA && nameB) return -1;
        if (nameA && !nameB) return 1;
        return nameA.localeCompare(nameB);
      });
    }
    this.setValue(false, isSearched);
  }

  setSelected(selectedLinks: any) {
    selectedLinks.forEach((element: any) => {
      let index = this.data.findIndex((item: any) => item.Id === element.Id);
      if (index >= 0) {
        this.data[index]['IsLinked'] = true;
      }
    });
  }

  getCombinations(chars) {
    let combinations = [];
    chars.forEach((char, i) => {
      let word = '';
      this.buildWord(word + ' ' + char, [i], chars, combinations);
    });
    return combinations;
  }

  buildWord(word, usedIndexes, chars, combinations) {
    // if (word.trim().split(' ').length > 1) {
    combinations.push(word.trim());
    // }
    chars.forEach((char, i) => {
      if (usedIndexes.indexOf(i) === -1) {
        let newUsedIndexesArray = Array.from(usedIndexes);
        newUsedIndexesArray.push(i);
        this.buildWord(
          word + ' ' + char,
          newUsedIndexesArray,
          chars,
          combinations
        );
      }
    });
  }

  filter() {
    this.pageStart = 1;
    let search = this.searchText.toLowerCase();

    let combinations =
      search.split(' ').length > 1
        ? this.getCombinations(search.split(' '))
        : [search];

    this.allFilteredDataList = this.allDataList.filter((item: any) => {
      let matched: boolean = false;
      combinations.forEach((element: string) => {
        // Se inserisco 2 parole devo cercare le combinazioni con almeno 2 parole
        const lengthSearch = search.split(' ').length;
        const lengthCombination = element.split(' ').length;
        if (lengthCombination >= lengthSearch) {
          if (
            item &&
            item.ObjectiveName &&
            (item?.ObjectiveName?.toLowerCase().includes(
              element.toLowerCase()
            ) ||
              item?.ObjectiveName?.toLowerCase().includes(
                element.toLowerCase()
              ))
          ) {
            matched = true;
          }
        }
      });
      return matched;
    });
    this.ref.detectChanges();
    this.getEmployees(true);
  }

  SendToBack() {
    // if (!this.almoustOneSelected() && this.isRequired) return;
    this.getResponse.emit({
      selected: this.allDataList.filter((item: any) => item.IsLinked),
      originalList: this.allDataList
    });
  }

  almoustOneSelected() {
    return (
      this.allFilteredDataList.filter((item: any) => item.IsLinked).length > 0
    );
  }

  deselectItem(item: any) {
    item['IsLinked'] = false;
    this.currentList.forEach((employee: any) => {
      if (employee.Id === item.Id) {
        employee['IsLinked'] = false;
      }
    });
    this.allDataList.forEach((employee: any) => {
      if (employee.Id === item.Id) {
        employee['IsLinked'] = false;
      }
    });
    this.allFilteredDataList.forEach((employee: any) => {
      if (employee.Id === item.Id) {
        employee['IsLinked'] = false;
      }
    });
    this.setValue(false);
    this.dropdown.hide();
  }

  selectItem(item: any) {
    if (!this.selectionMultiple) {
      if (item.IsLinked) {
        this.deselectItem(item);
      } else {
        item['IsLinked'] = item['IsLinked'] ? false : true;
      }
    } else {
      item['IsLinked'] = item['IsLinked'] ? false : true;
      this.allDataList.forEach((rec: any) => {
        if (rec.Id === item.Id) {
          rec['IsLinked'] = item.IsLinked;
        }
      });

      this.setValue(false);
    }
    this.dropdown.hide();
  }

  clearSelectionById(ids) {
    this.allDataList.forEach((e) => {
      e.IsLinked = ids.includes(e.Id);
    });
    this.allFilteredDataList.forEach((e) => {
      e.IsLinked = ids.includes(e.Id);
    });
    this.currentList.forEach((e) => {
      e.IsLinked = ids.includes(e.Id);
    });
    this.setValue(false);
  }
  onOutsideClick(event: any): void {
    const element = event.target.classList;
    if (element && element.length && !element.contains('categoryImg')) {
      this.dropdown.hide();
      this.currentList = this.allDataList;
    }
  }

  onHidden() {
    this.isOpened = false;
    this.searchable = false;
    this.setValue(true);
    this.SendToBack();
    this.setReadOnly();
  }

  onShown(): void {
    this.showMandatory = false;
    this.isOpened = true;
    this.setReadOnly();
  }

  async setValue(isClosed: boolean, isSearched = false) {
    if (!isSearched) {
      const selected = this.allDataList.filter((x) => x.IsLinked);
      if (selected.length == 1) {
        this.searchText = await selected[0].ObjectiveName;
      } else if (selected.length > 1) {
        this.searchText =
          `${selected.length} ` +
          this.coreService.getTranslation(
            'COMPANY_PERFORMANCE_REVIEW.REVIEWEES_TABLE.OKR_Linked'
          );
      } else {
        this.searchText = '';
      }
      if (isClosed) {
        this.showMandatory = !!!selected.length;
      }
    }
  }

  canSearch(event) {
    event.stopPropagation();
    this.searchable = true;
    this.searchText = '';
    this.searchInput.nativeElement.focus();
    this._renderer.removeAttribute(this.searchInput.nativeElement, 'readonly');
  }
}
